import { render, staticRenderFns } from "./Address.vue?vue&type=template&id=1a8050ce&scoped=true&"
import script from "./Address.vue?vue&type=script&lang=js&"
export * from "./Address.vue?vue&type=script&lang=js&"
import style0 from "./Address.vue?vue&type=style&index=0&id=1a8050ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8050ce",
  null
  
)

export default component.exports